import React from "react";
import Modal from "./index";
import Button from "../../Button/Button";
import { useTranslation } from "react-i18next";
import "./nosuitable.css";

interface NoSuitableAppointmentModalProps {
  open?: boolean;
  onClose?: () => void;
  onCheckAgain?: () => void;
  onContinueWithout?: () => void;
  id?: string;
  dataTestId?: string;
}

const NoSuitableAppointmentModal: React.FC<NoSuitableAppointmentModalProps> = ({
  open = false,
  onClose = () => {},
  onCheckAgain = () => {},
  onContinueWithout = () => {},
  id = "nosuitable-modal",
  dataTestId = "nosuitable-modal"
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} cssClasses="modalPopUp2" data-testid={dataTestId}>
      <div>
        <div id={id} className="modalPopUpContainer container my-1">
          <div
            id="nosuitable-title"
            className="py-lg-0 py-sm-0 h5 my-5 question-font-size text-center global-txt"
          >
            <span className="nosuitable-titleText">
              {t("APPT_NoSuitable_Title")}
            </span>
            <span id="nosuitable-body" className="nosuitable-body">
              {t("APPT_NoSuitable_Body")}
            </span>
          </div>

          <div className="modalButtonContainer button-positions pad-bot pt-lg-0 nosuitable-buttons">
            <Button
              id="nosuitable-btn-checkagain"
              className="button-class"
              onClick={onCheckAgain}
            >
              {t("APPT_NoSuitable_CheckAgain")}
            </Button>

            <Button
              id="nosuitable-btn-continue"
              className="button-class"
              onClick={onContinueWithout}
            >
              {t("APPT_NoSuitable_ContinueWithout")}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default NoSuitableAppointmentModal;
